<template>
  <div class="RelatedTopics mt-10">
    <header class="flex items-center justify-between">
      <lm-label no-margin>{{ numTopics }} related topics</lm-label>
      <lm-icon-button
        v-if="numTopics === 0"
        icon="add_circle"
        label="Connect topic"
        @click.prevent="openTopicsSearcher"
      />
      <lm-icon-button
        v-else
        icon="edit"
        label="Edit selection"
        outline
        @click.prevent="openTopicsSearcher"
      />
    </header>
    <ul class="space-y-2 py-4 border-b">
      <li
        v-for="topicId in tempTopics"
        :key="topicId"
        class="flex items-center text-gray-700 text-s leading-tight"
      >
        <lm-material-icon class="mr-2 text-gray-500" icon="notes" />
        <span
          class="cursor-pointer hover:text-gray-900 truncate"
          @click.prevent="openTopic(topicId)"
          >{{ getTitle(topicId) }}</span
        >
      </li>
    </ul>
    <span
      v-if="error"
      class="block w-full text-xs text-error border-t border-error pt-1"
    >
      {{ errorMessage }}
    </span>
  </div>
</template>

<script>
import LmLabel from '@/components/ui/LmLabel'
import LmMaterialIcon from '@/components/ui/LmMaterialIcon'
import {Modal} from '@/lib/definitions'
import LmIconButton from '@/components/ui/LmIconButton'

export default {
  name: 'RelatedTopics',
  components: {LmLabel, LmMaterialIcon, LmIconButton},
  props: {
    tempTopics: {
      type: Array,
      required: true
    },
    noRequired: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      error: false,
      errorMessage: ''
    }
  },
  computed: {
    numTopics() {
      return this.tempTopics.length
    }
  },
  methods: {
    getTitle(topicId) {
      const topic = this.$store.getters.getTopicByTopicId(topicId)
      return topic ? topic.title : ''
    },
    openTopic(id) {
      this.$store.dispatch('setCurrentTopics', this.tempTopics) // enables next/prev
      this.$router.pushQuery({topic: id})
    },
    openTopicsSearcher() {
      this.clearErrors()
      this.$router.pushQuery({submodal: Modal.TOPIC_SEARCHER})
    },
    validateData() {
      if (this.noRequired) return true
      if (this.numTopics === 0) {
        this.error = true
        this.errorMessage = 'Select at least one related topic'
        return false
      }
      return true
    },
    clearErrors() {
      this.error = false
      this.errorMessage = ''
    },
    reset() {
      this.clearErrors()
    }
  }
}
</script>
